"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("./enums");
var appender_console_native_1 = require("./appenders/appender.console-native");
exports.defaultConfig = {
    userId: 0,
    companyId: 0,
    minLogLevel: enums_1.LogLevel.Debug,
    appId: '',
    module: '',
    appenders: [new appender_console_native_1.ConsoleNativeAppender()],
    appenderTypes: [enums_1.AppenderType.ConsoleNative],
    mode: enums_1.ConfigMode.Release
};
exports.defaultSetConfigOptions = {
    keepExplicitlySetAppenders: false,
    mode: enums_1.ConfigMode.Release
};
//# sourceMappingURL=config.default.js.map